import React, { Component } from "react";
import { Card, Divider, Icon, Table, Button, Popconfirm, message, Spin } from "antd";
import { decode } from 'utf8'
import Modal from './Modal';
import ModalEdit from './ModalEdit';
import ModalDelete from './ModalDelete';

import { connect } from "react-redux";

import {
  fetchCategories,// fetchCoupon
} from "appRedux/actions/Coupons";

function confirm(e) {
  message.success('Eliminaste esta categoría.');
}

function cancel(e) {
  message.error('Esta categoría no se elimino.');
}

const columns = [
  {
    title: 'Categoría',
    dataIndex: 'name',
    key: 'name',
    render: text => <span>{text}</span>,
  }
  ,

  {
    title: 'Acción',
    key: 'action',


    render: (text, record) => (
      <span>
        <ModalEdit recording={record} />
        <ModalDelete recording={record} />
      </span>
    ),
  }

];


class Simple extends Component {

  componentDidMount() {
    this.props.fetchCategories();
  }

  render() {

    const { categories } = this.props;

    let categoriesDecode = [];
    categoriesDecode = categories.map( (category)=> {
      return ({
        id: category.id,
        name: decode(category.name),
        sortOrder: category.sortOrder
      })
    });

    if (categoriesDecode == 0) {
        return  <Spin className="gx-loader-container" />;
    }


    return (
      <Card title="Categorías">
        <Modal />
        <br />
        <Table className="gx-table-responsive" columns={columns} dataSource={categoriesDecode} />
      </Card>
    );
  }
};

function mapStateToProps({ categories }) {
  return {
    categories
  }
}

export default connect(mapStateToProps, { fetchCategories })(Simple);


// WEBPACK FOOTER //
// ./src/routes/main/Cupons/Category/Table.js